"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationStateEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class NavigationStateEvent extends web_ui_framework_1.Event {
}
exports.NavigationStateEvent = NavigationStateEvent;
//# sourceMappingURL=onboardingEvents.js.map